<template>
  <div :class="classList">
    <label>{{ label }}</label>
    <div v-if="description" class="description">{{ description }}</div>
    <textarea
      :rows="rows"
      class="form-control"
      :maxlength="maxLength"
      :placeholder="placeholder"
      v-model="inputVal"
    ></textarea>
    <p class="required-message" v-if="!inputVal && submitClicked && isRequired">
      This field is required.
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a textarea
Any error of textarea (for example: required field, invalid character, exceed length ...) is showed in this component */
export default {
  name: "TextAreaWithLabel",
  props: {
    /* Name of the textarea component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: String,
    // Number of rows of textarea
    rows: {
      type: Number,
      default: 4
    },
    // Max length of input
    maxLength: {
      type: Number
    },
    placeholder: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  // created() {
  //   this.$emit("input", this.label);
  // },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/TextAreaWithLabel.vue